import { Link } from "react-router-dom";
import { format } from "date-fns";

const Footer = () => {
  // Displaying the full date on the Footer
  const dateTime = format(new Date(), "yyyy");

  return (
    <>
      {/* <!-- CTA START --> */}
      <section className="position-relative z-index-2 py-0 mb-n7">
        <div className="container position-relative">
          <div className="bg-primary rounded position-relative overflow-hidden p-4 p-sm-5">
            {/* <!-- SVG decoration --> */}
            <figure className="position-absolute bottom-0 end-0 mb-n3">
              <svg
                className="fill-dark opacity-5"
                width="400"
                height="145"
                viewBox="0 0 400 145"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.437348 59.1519C0.291566 59.1519 0.121486 59.0549 0.0485943 58.9093C-0.0485943 58.7153 0 58.4728 0.194377 58.3515L60.0625 18.9131L70.899 31.5499C71.0205 31.6954 71.0691 31.8652 71.0205 32.035C70.9719 32.2047 70.8504 32.3503 70.6803 32.423L0.583131 59.1034C0.534537 59.1276 0.485943 59.1519 0.437348 59.1519ZM59.9167 19.8833L2.86706 57.4541L70.1701 31.8409L59.9167 19.8833Z"
                  fill="#202124"
                />
                <path
                  d="M0.851004 59.2979C0.63233 59.2979 0.413656 59.1281 0.389359 58.9098C0.365061 58.6673 0.510844 58.449 0.729518 58.4005L76.9253 38.7783L90.7504 55.7082L0.851004 59.2979ZM76.658 39.603L3.30501 58.4733L89.2683 55.0291L76.658 39.603Z"
                  fill="#202124"
                />
                <path
                  d="M70.8969 32.0817L70.168 32.0859L70.2189 40.7934L70.9478 40.7892L70.8969 32.0817Z"
                  fill="#202124"
                />
                <path
                  d="M72.6739 60.5583L0.851562 59.297V58.5694L71.9207 59.8064L71.7749 56.1439L72.5038 56.1196L72.6739 60.5583Z"
                  fill="#202124"
                />
                <path
                  d="M16.2865 52.6087L12.1719 55.7021L12.318 55.8959L16.4327 52.8025L16.2865 52.6087Z"
                  fill="#202124"
                />
                <path
                  d="M21.6213 50.601L17.4219 54.1704L17.5794 54.3551L21.7789 50.7856L21.6213 50.601Z"
                  fill="#202124"
                />
                <path
                  d="M27.4394 48.3802L23.1289 52.8901L23.3047 53.0576L27.6152 48.5476L27.4394 48.3802Z"
                  fill="#202124"
                />
                <path
                  d="M33.4909 46.1008L28.8633 51.4375L29.047 51.5962L33.6746 46.2596L33.4909 46.1008Z"
                  fill="#202124"
                />
                <path
                  d="M39.2488 43.9004L34.6523 49.9487L34.8459 50.0953L39.4424 44.047L39.2488 43.9004Z"
                  fill="#202124"
                />
                <path
                  d="M45.6875 41.4253L40.9922 48.2988L41.1929 48.4355L45.8883 41.562L45.6875 41.4253Z"
                  fill="#202124"
                />
                <path
                  d="M52.8514 38.7208L47.2773 46.6982L47.4766 46.837L53.0507 38.8596L52.8514 38.7208Z"
                  fill="#202124"
                />
                <path
                  d="M59.6794 36.1172L53.5391 45.0894L53.7397 45.2262L59.88 36.254L59.6794 36.1172Z"
                  fill="#202124"
                />
                <path
                  d="M66.3562 33.5847L59.6758 43.5107L59.8775 43.646L66.5579 33.72L66.3562 33.5847Z"
                  fill="#202124"
                />
                <path
                  d="M70.4459 34.1845L65.8281 41.9414L66.037 42.0653L70.6548 34.3084L70.4459 34.1845Z"
                  fill="#202124"
                />
                <path
                  d="M393.661 145L392.273 144.88L393.152 140.401L394.54 140.521L393.661 145ZM189.936 138.628C187.484 138.568 185.124 138.297 182.949 137.846L183.366 136.975C185.448 137.395 187.669 137.636 190.028 137.696L189.936 138.628ZM196.969 138.357L196.737 137.455C198.866 137.245 201.133 136.884 203.4 136.433L203.817 137.305C201.503 137.786 199.19 138.147 196.969 138.357ZM395.419 136.073L394.031 135.953C394.309 134.45 394.586 132.977 394.864 131.474L396.252 131.564C395.974 133.067 395.697 134.57 395.419 136.073ZM176.518 135.862C174.621 135.021 172.816 133.969 171.243 132.766L172.307 132.195C173.834 133.337 175.5 134.329 177.304 135.141L176.518 135.862ZM210.387 135.712L209.832 134.9C211.868 134.329 213.95 133.668 215.986 132.917L216.633 133.698C214.598 134.45 212.469 135.111 210.387 135.712ZM222.695 131.354L221.954 130.602C223.851 129.791 225.748 128.919 227.599 128.017L228.432 128.739C226.535 129.67 224.592 130.542 222.695 131.354ZM167.31 128.949C166.246 127.687 165.32 126.274 164.488 124.771L165.783 124.47C166.57 125.943 167.495 127.296 168.513 128.528L167.31 128.949ZM396.992 127.085L395.604 126.995C395.882 125.462 396.113 123.959 396.298 122.517L397.686 122.607C397.501 124.05 397.27 125.552 396.992 127.085ZM233.799 125.883L232.874 125.192C234.586 124.23 236.252 123.208 237.825 122.216L237.917 122.156L238.889 122.787L238.797 122.847C237.27 123.869 235.558 124.891 233.799 125.883ZM162.59 120.382C162.128 118.94 161.804 117.437 161.619 115.874L163.007 115.814C163.192 117.347 163.516 118.819 163.932 120.232L162.59 120.382ZM243.794 119.541L242.776 118.91C244.303 117.858 245.876 116.745 247.449 115.603L248.467 116.204C246.894 117.377 245.321 118.489 243.794 119.541ZM398.334 118.098L396.946 118.038C397.131 116.505 397.316 115.002 397.455 113.559L398.843 113.619C398.704 115.062 398.519 116.565 398.334 118.098ZM253.094 112.838L252.03 112.237C253.464 111.155 254.945 110.042 256.518 108.81L257.582 109.381C256.009 110.614 254.528 111.756 253.094 112.838ZM162.822 111.335L161.434 111.305C161.48 109.862 161.619 108.329 161.896 106.766L163.285 106.856C163.007 108.419 162.868 109.922 162.822 111.335ZM399.213 109.081L397.825 109.051C397.918 107.548 398.01 106.015 398.057 104.542L399.445 104.572C399.398 106.045 399.306 107.578 399.213 109.081ZM262.024 105.894L260.96 105.323C262.44 104.151 263.875 103.009 265.355 101.837L266.419 102.408C264.939 103.58 263.504 104.752 262.024 105.894ZM164.21 102.408L162.822 102.257C163.007 101.476 163.238 100.664 163.47 99.8528C163.655 99.1615 163.886 98.5002 164.071 97.8089L165.413 97.9892C165.182 98.6806 164.996 99.3418 164.811 100.033C164.58 100.845 164.395 101.656 164.21 102.408ZM398.149 100.063C398.149 98.5603 398.103 97.0274 398.01 95.5545L399.398 95.5245C399.491 96.9973 399.491 98.5303 399.537 100.033L398.149 100.063ZM270.815 98.921L269.751 98.3499C271.232 97.1777 272.666 96.0054 274.146 94.8632L275.211 95.4343C273.73 96.5765 272.249 97.7488 270.815 98.921ZM166.94 93.6308L165.598 93.4204C166.107 92.0377 166.662 90.5949 167.264 89.0319L168.606 89.2724C168.004 90.8054 167.449 92.2181 166.94 93.6308ZM279.606 91.9476L278.542 91.3765C280.115 90.1441 281.596 89.0019 283.03 87.9198L284.094 88.5209C282.66 89.573 281.179 90.7152 279.606 91.9476ZM397.686 91.0759C397.548 89.573 397.362 88.0701 397.131 86.5972L398.519 86.507C398.751 87.9799 398.936 89.5129 399.074 91.0158L397.686 91.0759ZM288.629 85.1244L287.611 84.5232C289.184 83.381 290.757 82.2388 292.284 81.1868L293.302 81.818C291.775 82.87 290.202 83.9822 288.629 85.1244ZM170.41 84.914L169.068 84.6735C169.67 83.2307 170.317 81.7879 170.919 80.3151L172.261 80.5556C171.659 82.0284 171.012 83.4712 170.41 84.914ZM396.298 82.1486C396.252 81.9082 396.206 81.6677 396.159 81.4272C395.882 80.1648 395.512 78.9324 395.095 77.7602L396.437 77.5498C396.854 78.7521 397.224 80.0145 397.501 81.307C397.548 81.5475 397.594 81.7879 397.64 82.0284L396.298 82.1486ZM298.114 78.5717L297.143 77.9405C298.808 76.8584 300.52 75.7763 302.14 74.7844L303.111 75.4457C301.446 76.4376 299.78 77.4896 298.114 78.5717ZM174.158 76.2272L172.816 75.9867C173.464 74.544 174.065 73.1012 174.713 71.6584L176.055 71.8988C175.453 73.3416 174.806 74.7844 174.158 76.2272ZM393.198 73.4619C392.412 72.0491 391.44 70.6665 390.422 69.404L391.625 68.9832C392.689 70.2757 393.661 71.6884 394.494 73.1613L393.198 73.4619ZM308.201 72.4399L307.276 71.7486C309.08 70.7566 310.885 69.7647 312.643 68.863L313.522 69.5844C311.764 70.4861 309.959 71.448 308.201 72.4399ZM177.859 67.5404L176.518 67.3C177.165 65.7369 177.721 64.3242 178.23 62.9415L179.571 63.152C179.062 64.5346 178.507 65.9774 177.859 67.5404ZM319.074 66.9092L318.288 66.1578C320.185 65.2861 322.174 64.4444 324.118 63.6329L324.858 64.3843C322.868 65.1959 320.971 66.0375 319.074 66.9092ZM386.674 65.7069C385.24 64.5346 383.667 63.4525 382.001 62.4907L382.926 61.7993C384.685 62.7913 386.304 63.9034 387.785 65.1358L386.674 65.7069ZM330.781 62.16L330.133 61.3785C330.364 61.2884 330.595 61.1982 330.873 61.1381C332.724 60.5068 334.575 59.9057 336.425 59.3947L336.981 60.2363C335.176 60.7473 333.325 61.3184 331.521 61.9496C331.243 62.0097 331.012 62.0699 330.781 62.16ZM376.449 59.9658C374.505 59.2444 372.423 58.6432 370.249 58.1924L370.665 57.3207C372.932 57.8016 375.107 58.4028 377.143 59.1542L376.449 59.9658ZM181.191 58.7334L179.849 58.5531C180.358 57.0502 180.821 55.5473 181.237 54.1345L182.625 54.2848C182.163 55.7276 181.7 57.2305 181.191 58.7334ZM343.366 58.6432L342.949 57.7716C345.217 57.3207 347.53 56.9299 349.751 56.6594L349.982 57.5612C347.808 57.8317 345.587 58.1924 343.366 58.6432ZM363.632 57.2606C361.457 57.0802 359.144 57.0201 356.83 57.0802L356.784 56.1785C359.19 56.1184 361.55 56.1785 363.817 56.3588L363.632 57.2606ZM183.689 49.8362L182.301 49.716C182.625 48.2131 182.903 46.7102 183.134 45.2674L184.522 45.3576C184.291 46.8004 184.013 48.3033 183.689 49.8362ZM184.985 40.8188L183.597 40.7888C183.643 39.857 183.689 38.9252 183.689 38.0535C183.689 37.4824 183.689 36.9113 183.643 36.3101L185.031 36.2801C185.031 36.8512 185.077 37.4523 185.077 38.0234C185.077 38.9552 185.031 39.887 184.985 40.8188ZM75.8812 36.6708L74.8633 36.0396C76.2976 35.0777 77.7783 33.9956 79.4902 32.7032L80.5544 33.3043C78.8425 34.5968 77.3156 35.709 75.8812 36.6708ZM183.227 31.8315C182.995 30.3286 182.671 28.8557 182.301 27.4129L183.689 27.2626C184.106 28.7355 184.383 30.2384 184.615 31.7714L183.227 31.8315ZM85.0889 29.8777L84.0247 29.3066C85.1814 28.4049 86.3844 27.4731 87.5874 26.5112L88.4665 25.8199L89.5307 26.391L88.6516 27.0823C87.4486 28.0141 86.2456 28.9459 85.0889 29.8777ZM180.821 23.0545C180.451 22.1528 180.034 21.251 179.618 20.3493C179.34 19.8383 179.062 19.2973 178.785 18.7863L180.08 18.4556C180.404 18.9967 180.682 19.5077 180.96 20.0487C181.422 20.9505 181.839 21.8823 182.209 22.784L180.821 23.0545ZM93.9264 22.9343L92.8622 22.3632C94.5279 21.1007 96.0085 19.9585 97.3966 18.9366L98.4608 19.5377C97.0727 20.5296 95.5921 21.6418 93.9264 22.9343ZM103.088 16.1712L102.07 15.5701C103.736 14.3978 105.355 13.3157 106.928 12.3238L107.9 12.955C106.373 13.9169 104.753 14.999 103.088 16.1712ZM175.916 14.7585C174.806 13.4359 173.603 12.1735 172.261 11.0012L173.371 10.4602C174.759 11.6625 176.009 12.9851 177.165 14.3076L175.916 14.7585ZM112.989 9.91915L112.064 9.22782C113.915 8.20585 115.766 7.24399 117.524 6.40236L118.357 7.12376C116.598 7.96538 114.794 8.89718 112.989 9.91915ZM167.819 7.63474C166.153 6.58271 164.441 5.62085 162.59 4.77923L163.377 4.02778C165.274 4.89946 167.079 5.89138 168.791 6.97347L167.819 7.63474ZM124.094 4.68906L123.4 3.90755C125.482 3.12604 127.611 2.4347 129.693 1.89366L130.202 2.73528C128.212 3.24627 126.176 3.90755 124.094 4.68906ZM156.668 2.58499C154.586 1.98383 152.411 1.53296 150.19 1.26244L150.468 0.390755C152.735 0.691335 155.002 1.14221 157.223 1.77342L156.668 2.58499ZM136.726 1.41273L136.448 0.541045C138.762 0.210406 141.121 0.030058 143.435 0L143.481 0.901741C141.26 0.931799 138.993 1.11215 136.726 1.41273Z"
                  fill="#202124"
                />
              </svg>
            </figure>

            <div className="row g-4 position-relative">
              {/* <!-- Title and inputs --> */}
              <div className="col-lg-6">
                {/* <!-- Title --> */}
                <h3 className="text-white">
                  Let's talk about your digital agency goals
                </h3>

                {/* <!-- Search --> */}
                <form className="col-md-10 bg-body rounded-2 p-2 mt-4">
                  <div className="input-group">
                    <input
                      className="form-control focus-shadow-none border-0 me-1"
                      type="email"
                      placeholder="Your email address"
                    />
                    <button type="button" className="btn btn-dark rounded-2">
                      Subscribe
                    </button>
                  </div>
                </form>
              </div>

              {/* <!-- Content --> */}
              <div className="col-lg-5 col-xl-4 ms-auto text-lg-end">
                <ul className="list-group list-group-borderless mb-0">
                  <li className="list-group-item mb-0">
                    <Link to="#" className="text-white fw-normal">
                      <i className="bi bi-headset me-1"></i> Call on: +(231) 776
                      765707{" "}
                    </Link>
                  </li>
                  <li className="list-group-item text-white fw-normal mb-0">
                    <i className="bi bi-clock me-1"></i> Time: 9am to 5pm
                    (Sunday close)
                  </li>
                  <li className="list-group-item mb-0">
                    <Link to="#" className="text-white fw-normal">
                      <i className="bi bi-envelope me-1"></i> Email:
                      info@roviagatetechnology.com
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <!-- Row END --> */}
          </div>
        </div>
      </section>
      {/* <!-- CTA END --> */}

      {/* // <!-- Footer Start --> */}
      <div
        className="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-4 col-md-6 col-12">
              <h5 className="text-light mb-4">Address</h5>
              <p className="mb-2 text-light">
                <i className="fas fa-map-marker-alt me-3"></i>15<sup>th</sup> &
                16
                <sup>th</sup> Sinkor, Liberia
              </p>
              <p className="mb-2 text-light">
                <i className="fas fa-phone-alt me-3"></i>
                <Link to="tel:+(231) 776-765-707" className="text-white">
                  +(231) 776 765707
                </Link>
              </p>
              <p className="mb-2 text-light">
                <i className="fa fa-envelope me-3"></i>
                <Link
                  to="mailto:info@roviagatetechnology.com"
                  className="text-white"
                >
                  info@roviagatetechnology.com
                </Link>
              </p>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <h5 className="text-light mb-4">Quick Links</h5>
              <Link className="btn btn-link" to="/about-us">
                About Us
              </Link>
              <Link className="btn btn-link" to="/what-we-do">
                Services
              </Link>
              {/* <Link className="btn btn-link" to="/projects">
                Projects &#038; Portfolio
              </Link> */}
              {/* <Link className="btn btn-link" to="/news">
                News
              </Link> */}
              <Link className="btn btn-link" to="/contact-us">
                Contact Us
              </Link>
              {/* <Link className="btn btn-link" to="/">
                Terms &#038; Condition
              </Link> */}
              <Link className="btn btn-link" to="/faq">
                Support
              </Link>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <h5 className="text-light mb-4">Popular Links</h5>
              <Link className="btn btn-link" to="/about-us">
                About Us
              </Link>
              <Link className="btn btn-link" to="/what-we-do">
                Services
              </Link>
              {/* <Link className="btn btn-link" to="/projects">
                Projects &#038; Portfolio
              </Link>
              <Link className="btn btn-link" to="/news">
                News
              </Link> */}
              <Link className="btn btn-link" to="/contact-us">
                Contact Us
              </Link>
              {/* <Link className="btn btn-link" to="/">
                Terms &#038; Condition
              </Link> */}
              <Link className="btn btn-link" to="/faq">
                Support
              </Link>
            </div>
            <div className="col-lg-2 col-md-6 col-12">
              <h5 className="text-light mb-4">Follow on</h5>

              <div className="d-flex pt-2">
                <Link
                  className="btn btn-square btn-outline-secondary rounded-circle me-1"
                  to="https://twitter.com/RoviagateTechn1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </Link>
                <Link
                  className="btn btn-square btn-outline-secondary rounded-circle me-1"
                  to="https://www.facebook.com/RoviaGate"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link
                  className="btn btn-square btn-outline-secondary rounded-circle me-1"
                  to="https://www.instagram.com/roviagate/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link
                  className="btn btn-square btn-outline-secondary rounded-circle me-0"
                  to="https://www.linkedin.com/company/roviagate-technology-inc./about/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </div>

              {/* <p className="text-light">Subscribe now for updates.</p> */}
              {/* <div
                className="position-relative mx-auto"
                style={{ maxWidth: "400px" }}
              >
                <form action="mailto:jeremiahalfred56@gmail.com" method="post">
                  <input
                    className="form-control bg-transparent border-secondary w-100 py-3 ps-4 pe-5"
                    type="text"
                    placeholder="Your email"
                  />
                  <button
                    type="button"
                    name="submit"
                    className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                  >
                    SignUp
                  </button>
                </form>
              </div> */}
            </div>
          </div>
        </div>
        <div className="container-fluid copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center text-md-center mb-3 mb-md-0 text-light">
                Copyright&copy; {dateTime} -{" "}
                <Link to="/">RoviaGate Technology, LLC</Link> | All Right
                Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* //  <!-- Footer End --> */}
    </>
  );
};

export default Footer;
